var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 12 10.7",
    style: {
      enableBackground: "new 0 0 12 10.7"
    },
    xmlSpace: "preserve",
    width: "15px",
    height: "15px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#020202;}\n\t.st1{clip-path:url(#SVGID_00000017508488190680503150000007508601764961635229_);}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#092540;}\n\t.st3{fill:#20201F;}\n\t.st4{fill:none;stroke:#020202;stroke-width:1.3871;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st6{fill:none;stroke:#20201F;stroke-miterlimit:10;}\n\t.st7{fill:none;stroke:#20201F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st8{fill:none;stroke:#20201F;stroke-linecap:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Path_225_00000035504149615866582220000012924148214749352578_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.3,4.7H0.7C0.3,4.7,0,5,0,5.3S0.3,6,0.7,6h10.7C11.7,6,12,5.7,12,5.3S11.7,4.7,11.3,4.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_225_00000004531508858008268680000009917991785926165658_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.8,4.8L6.4,0.2C6.2-0.1,5.7,0,5.5,0.2S5.3,0.9,5.6,1.2l4.8,4.2L5.6,9.5c-0.3,0.2-0.3,0.7-0.1,0.9 s0.7,0.3,0.9,0.1l5.3-4.7C12.1,5.6,12.1,5.1,11.8,4.8z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.056e86c0.svg";
export { ForwardRef as ReactComponent };